import { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';

// True when the signed-in member has at least one diary-enabled gymnast
// (themselves or a child), whatever their role. A child sign in checks
// their own diary.
export default function useHasDiary() {
  const { user } = useAuth();
  const [has, setHas] = useState(false);
  useEffect(() => {
    if (!user) { setHas(false); return undefined; }
    let cancelled = false;
    axios.get('/api/training-diary/mine')
      .then(res => { if (!cancelled) setHas(res.data.length > 0); })
      .catch(() => { if (!cancelled) setHas(false); });
    return () => { cancelled = true; };
  }, [user]);
  return has;
}
